import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { Row, Table, Button, message, Input } from "antd"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

@observer
export default class BatchShareModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedRowKeys: [],
      selectedData: [],
      username: ""
    }
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    if (selectedRowKeys.length > 50) return message.warning("不能选择超过50条家系")
    this.setState({
      selectedData: selectedRows,
      selectedRowKeys: selectedRowKeys
    })
  }

  clearShareData = () => {
    this.setState({
      selectedRowKeys: [],
      selectedData: [],
      username: ""
    })
  }

  shareInputChange = (e) => {
    this.setState({
      username: e.target.value
    })
  }

  handleConfirmShare = () => {
    const { onClose } = this.props
    const { batchShareGroup, list: { filterData } } = this.props.store
    const { username, selectedRowKeys } = this.state
    const body = {
      username,
      groupIds: selectedRowKeys
    }
    if (username === "" || username === undefined || username === null) {
      return message.error("请输入要分享的用户")
    }
    if (selectedRowKeys.length === 0) {
      return message.error("请先选择要分享的家系")
    }
    batchShareGroup(body)
      .then(res => {
        this.clearShareData()
        onClose()
        filterData()
        message.success("分享成功")
      }, err => {
        message.error(err.message)
      })
  }

  render() {
    const { selectedRowKeys, username } = this.state
    const { onClose, tableData } = this.props
    const { list: { totalCount, currentPageIndex, queryMap } } = this.props.store
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    }
    const columns = [{
      title: "数据类型",
      className: "ta-l",
      dataIndex: "appName",
    }, {
      title: "所在家系",
      className: "ta-l",
      dataIndex: "groupName",
    }, {
      title: "送检单位",
      className: "ta-l",
      dataIndex: "organization",
    }, {
      title: "文件数量",
      className: "ta-l",
      dataIndex: "dataCount",
    }, {
      title: "数据大小",
      className: "ta-l",
      dataIndex: "totalSize",
    }, {
      title: "创建时间",
      className: "ta-l",
      dataIndex: "createTime",
    }]
    return (
      <MaterialModal
        className="pgx-report-share"
        title="批量分享"
        visible
        width={1000}
        footer={(
          <Row type="flex" justify="center" align="middle">
            <Button
              type="primary"
              size="default"
              className="export-btn"
              onClick={() => this.handleConfirmShare()}
            >
              确认分享
            </Button>
          </Row>
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Row type="flex" justify='start' align='middle' className='subtitle'>
          <i></i>
          <MaterialFormItem
            className="share-item"
            labelText="共享给"
            labelWidth={34}
            justify="space-between"
          >
            {/* <Select
              combobox
              style={{ width: 345 }}
              value={username}
              onChange={this.shareInputChange}
              placeholder="请输入用户名或手机号码"
            >
              <Option value="jbsx">jbsx</Option>
            </Select> */}
            <Input
              value={username}
              onChange={this.shareInputChange}
              placeholder="请输入用户名或手机号码"
            />
          </MaterialFormItem>
        </Row>
        <Table
          columns={columns}
          rowSelection={rowSelection}
          dataSource={tableData.slice()}
          rowKey={record => record.groupId}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/report/BatchShareModal.js